import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';
import { useAdminMode } from '../context/AdminModeContext';
import { toast } from '../hooks/use-toast';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [adminLogoTapCount, setAdminLogoTapCount] = useState(0);
  const navigate = useNavigate();
  const { adminModeEnabled, disableAdminMode } = useAdminMode();

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      setEmail('');
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div
              className="inline-flex items-center mb-6 select-none cursor-default"
              onClick={() => {
                setAdminLogoTapCount((prev) => {
                  const next = Number(prev || 0) + 1;
                  if (next >= 25) {
                    navigate('/admin');
                    return 0;
                  }
                  return next;
                });
              }}
            >
              <img
                src="/logos/logo.png"
                alt="Ditris"
                className="h-28 w-auto"
              />
            </div>
            <h3 className="font-medium text-sm mb-4 tracking-wide">ABOUT</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:opacity-60 transition-opacity">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:opacity-60 transition-opacity">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/sustainability" className="hover:opacity-60 transition-opacity">
                  Sustainability
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-medium text-sm mb-4 tracking-wide">CUSTOMER SERVICE</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/contact" className="hover:opacity-60 transition-opacity">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="hover:opacity-60 transition-opacity">
                  Shipping & Returns
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:opacity-60 transition-opacity">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/size-guide" className="hover:opacity-60 transition-opacity">
                  Size Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-medium text-sm mb-4 tracking-wide">LEGAL</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:opacity-60 transition-opacity">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:opacity-60 transition-opacity">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-medium text-sm mb-4 tracking-wide">STAY CONNECTED</h3>
            <p className="text-sm mb-4">Subscribe to receive updates, access to exclusive deals, and more.</p>
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full sm:flex-1 border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:border-black transition-colors"
              />
              <button 
                type="submit"
                className="w-full sm:w-auto bg-black text-white px-6 py-2 text-sm font-medium hover:bg-gray-800 transition-colors"
              >
                SIGN UP
              </button>
            </form>
            <div className="flex gap-4">
              <a href="#" className="hover:opacity-60 transition-opacity">
                <Instagram size={20} />
              </a>
              <a href="#" className="hover:opacity-60 transition-opacity">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:opacity-60 transition-opacity">
                <Twitter size={20} />
              </a>
            </div>
            <div className="mt-4">
              {adminModeEnabled ? (
                <button
                  type="button"
                  onClick={() => {
                    disableAdminMode();
                    toast({ title: 'Admin signed out', description: 'Admin mode disabled.' });
                    navigate('/home');
                  }}
                  className="text-sm hover:opacity-60 transition-opacity"
                >
                  Admin Sign Out
                </button>
              ) : null}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-sm text-gray-500">
          <p className="text-center">&copy; 2026 Dïtris. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;